import script from "./OnboardingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OnboardingPage.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__